namespace Umbrella {
    import MediaModel = Umbrella.Media.MediaClearedModel;
    @Pipe('Umbrella', 'mediaIsDeleted')
    class MediaIsDeletedFilter {
        public transform(input: MediaModel): boolean {
            return input && input.type && input.type === 'MediaClearedModel';
        }
    }
}
